import { ROUTE_PATH } from "common/constants/sm-constants";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class GroupDetailsGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
        super(
            'Add Group',
            ROUTE_PATH.groups,
            ROUTE_PATH.groupsAdd,
            false,
            false,
            8,
            false,
            false,
            ['name'],
            false,
            [],
            { isDownloadExcel: false, excelFileName: '', btnLabel: '', headers: []},
            false,
            null,
            false,
            false,
            false,
            null,
            null,
            false,
            null,
            {
                isPreview: false,
                isPreviewType: 'VIDEO',
                isEnvUrl: false,
                linkKey: ['filePath'],
                previewName: ''
            },
            {
                isTabSwitch: false,
                label: '',
                isChecked: false
            },
            false,
            true,
            false,
            [],
            false,
            { isExtraActions: false, btnLabel: '' },
            {isCheckboxEmit: true, emitKey: 'id', checkedKey: 'group_student_list_id', valueKey: ''}
        )
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const name = new Headers('Student Name', 'name', false, false, 'text');
        const email = new Headers('Email Id', 'email', false, false, 'text');
        const branch_name = new Headers('Branch', 'branch_name', false, false, 'text');
        const region = new Headers('Region', 'region', false, false, 'text');
        headers.push(name);
        headers.push(email);
        headers.push(branch_name);
        headers.push(region);
        return headers;
    }
}